import {
    FETCH_ADMIN_MESSAGES,
    FETCH_ADMIN_MESSAGES_SUCCESS,
    FETCH_ADMIN_MESSAGES_FAILED,
    SEND_ADMIN_MESSAGE,
    EDIT_ADMIN_CHAT,
    FETCH_CHAT_READ_SUCCESS,
    UPDATE_ADMIN_CHAT_STATUS
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { onValue, child, set, remove, get, update } from "firebase/database";

export const fetchAdmUserChatMessages = (userId) => (dispatch) => {

    const {
        admchatRef
    } = firebase;
  
    dispatch({
        type: FETCH_ADMIN_MESSAGES,
        payload: null,
    });
    if (!userId || typeof userId !== 'string' || !userId.trim()) {
        dispatch({
            type: FETCH_ADMIN_MESSAGES_FAILED,
            payload: store.getState().languagedata?.defaultLanguage?.chat_not_found || "Chat not found",
        });
        return;
    }
    onValue(child(admchatRef, userId.trim()), snapshot => {
        if(snapshot.val()){
            const val = snapshot.val();
            let rawMessages = val.messages;
            let chats = Array.isArray(rawMessages)
                ? rawMessages
                : (rawMessages && typeof rawMessages === 'object' ? Object.values(rawMessages) : []);
            dispatch({
                type: FETCH_ADMIN_MESSAGES_SUCCESS,
                payload: {
                    messages: chats,
                    status: val.status || null,
                    operatorRequested: Boolean(val.operatorRequested)
                }
            });
        }else{
            dispatch({
                type: FETCH_ADMIN_MESSAGES_FAILED,
                payload: store.getState().languagedata.defaultLanguage.chat_not_found,
            });
        }
    })
};


export const fetchAdmAllChatMessages = () => (dispatch) => {

    const {
        admchatRef,
        chatReadRef
    } = firebase;
  
    dispatch({
        type: FETCH_ADMIN_MESSAGES,
        payload: null,
    });
    onValue(chatReadRef,  snapshot => {
        if(snapshot.val()){
            let readObj = snapshot.val();
            dispatch({
                type: FETCH_CHAT_READ_SUCCESS,
                payload: readObj
            })      
        }   
    })
    onValue(admchatRef, snapshot => {
        if(snapshot.val()){
            let snap = snapshot.val();
            let chats = [];
            for (let key in snap) {
                let chat =  snap[key];
                if (chat && typeof chat === 'object') {
                    chat.id = key;
                    chat.userId = chat.userId || key;
                    chats.push(chat);
                }
            }
            dispatch({
                type: FETCH_ADMIN_MESSAGES_SUCCESS,
                payload:  chats
            })
        }else{
            dispatch({
                type: FETCH_ADMIN_MESSAGES_FAILED,
                payload: store.getState().languagedata.defaultLanguage.chat_not_found,
            });
        }
    })
};

export const sendAdmMessage = (data) => async (dispatch) => {

    const {
        admchatRef,
        chatReadRef,
        singleUserRef
    } = firebase;

    const msgTime = new Date().getTime();

    const msg = {
        text: data.message,
        createdAt: msgTime,
        from: data.from,
    };

    let userProfile = null;
    try {
        const userSnap = await get(singleUserRef(data.userId));
        userProfile = userSnap.val();
    } catch (e) {
        console.log('Error fetching user profile for chat:', e);
    }

    const userName = (userProfile && userProfile.firstName)
        ? `${userProfile.firstName} ${userProfile.lastName || ''}`.trim()
        : (data.userName || 'User');
    const profileImg = (userProfile && userProfile.profile_image)
        ? userProfile.profile_image
        : (data.profileImage || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png');

    if(data.from === 'admin'){
        if (userProfile && userProfile.pushToken) {
            RequestPushMsg(
                userProfile.pushToken,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title  + store.getState().languagedata.defaultLanguage.chat_requested,
                    msg: data.message,
                    screen: 'admChat',
                }
            );
        }
    } else {
        set(child(chatReadRef, data.userId),true);
    }

    onValue(child(admchatRef, data.userId), async snapshot => {
        if(snapshot.val()){
            let snap = snapshot.val();
            let messagesList = Array.isArray(snap.messages)
                ? snap.messages
                : (snap.messages && typeof snap.messages === 'object' ? Object.values(snap.messages) : []);
            messagesList.push(msg);
            snap.messages = messagesList;
            snap.lastUpdateTime = msgTime;  
            snap.userName = userName;
            if (data.from === 'admin') {
                snap.status = 'Active';
                snap.operatorRequested = false;
            }
            await set(child(admchatRef, data.userId), snap);
        } else{
            await set(child(admchatRef, data.userId), {    
                userId: data.userId,
                lastUpdateTime: msgTime,
                userName: userName,
                profileImage: profileImg,
                messages: [
                    msg
                ]
            });     
        }
    },{onlyOnce:true});


    dispatch({
        type: SEND_ADMIN_MESSAGE,
        payload: msg,
    });
}

export const editChat = (chat, method) => async (dispatch) => {
    const {
      chatEditRef,
      chatReadRef
    } = firebase;

    dispatch({
      type: EDIT_ADMIN_CHAT,
      payload: { method, chat }
    });
    const targetUserId = chat && (chat.userId || chat.id);
    if (!targetUserId || typeof targetUserId !== 'string' || !targetUserId.trim()) {
        return;
    }
    const cleanUid = targetUserId.trim();
    if (method === 'Read') {
        try {
            set(child(chatReadRef, cleanUid), false);
        } catch (e) {
            console.log("Error marking chat read:", e);
        }
    }
    if (method === 'Delete') {
        try {
            remove(chatEditRef(cleanUid));
        } catch (e) {
            console.log("Error deleting chat:", e);
        }
    }
  }

  export const removeChatWithUserDelete = async(userId) =>{
    const {
        chatEditRef
      } = firebase;

      if (!userId || typeof userId !== 'string' || !userId.trim()) return;
      try{
        remove(chatEditRef(userId.trim()))
      }catch(error){
        console.log("error removing chat",error)
      }

  }

  export const updateChatStatus = (userId, status) => async (dispatch) => {
    const {
      admchatRef
    } = firebase;
    if (!userId || typeof userId !== 'string' || !userId.trim()) return;
    try {
      const isOperatorRequested = status === 'Operator Requested';
      await update(child(admchatRef, userId.trim()), {
        status: status,
        operatorRequested: isOperatorRequested,
        lastUpdateTime: new Date().getTime()
      });
      if (dispatch) {
        dispatch({
          type: UPDATE_ADMIN_CHAT_STATUS,
          payload: {
            status: status,
            operatorRequested: isOperatorRequested
          }
        });
      }
    } catch (e) {
      console.log('Error updating chat status:', e);
    }
  };

  export const checkChatSessionStatus = (userId) => async (dispatch) => {
    const { admchatRef } = firebase;
    if (!userId || typeof userId !== 'string' || !userId.trim()) return null;
    try {
      const snap = await get(child(admchatRef, userId.trim()));
      if (snap.exists() && snap.val()) {
        const val = snap.val();
        const status = val.status || null;
        const operatorRequested = Boolean(val.operatorRequested);
        if (dispatch) {
          dispatch({
            type: UPDATE_ADMIN_CHAT_STATUS,
            payload: { status, operatorRequested }
          });
        }
        return { status, operatorRequested };
      }
      if (dispatch) {
        dispatch({
          type: UPDATE_ADMIN_CHAT_STATUS,
          payload: { status: null, operatorRequested: false }
        });
      }
      return { status: null, operatorRequested: false };
    } catch (e) {
      console.log('Error checking chat session status:', e);
      return null;
    }
  };

  export const markSosActivated = (userId, messageCreatedAt) => async () => {
    const { admchatRef } = firebase;
    if (!userId || typeof userId !== 'string' || !userId.trim()) return;
    try {
      const chatSnap = await get(child(admchatRef, userId.trim()));
      if (chatSnap.exists()) {
        const snap = chatSnap.val();
        if (snap && snap.messages) {
          let messagesList = Array.isArray(snap.messages)
            ? [...snap.messages]
            : Object.values(snap.messages);
          let modified = false;
          messagesList = messagesList.map((m) => {
            if (m && (m.createdAt === messageCreatedAt || String(m.createdAt) === String(messageCreatedAt))) {
              modified = true;
              return { ...m, sosActivated: true };
            }
            return m;
          });
          if (modified) {
            await update(child(admchatRef, userId), { messages: messagesList });
          }
        }
      }
    } catch (e) {
      console.log('Error marking SOS activated in RTDB:', e);
    }
  };

  export const chatMail = async(msgDetails) => {
    const {
      config
    } = firebase;

    let url = `https://${config.projectId}.web.app/sendChatMail`;

    const isOpReq = msgDetails.isOperatorRequest;
    const prefix = isOpReq ? '[OPERATOR REQUEST]' : '[Support Chat]';
    const finalSubject = msgDetails.subject
      ? (msgDetails.subject.startsWith('[') ? msgDetails.subject : `${prefix} ${msgDetails.subject}`)
      : `${prefix} ${msgDetails.userName || 'User'}: ${(msgDetails.message || '').substring(0, 50)}`;

    const body = {
      msgDetails: {
        ...msgDetails,
        subject: finalSubject,
        isOperatorRequest: isOpReq
      }
    };
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    });

    return await response.json();
  }


